'use client';

import { Box } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import { lighten } from '@mui/material/styles';

export const LinearProgressBar = ({ value, backgroundColor }: { value: number; backgroundColor: string }) => {
	const roundedValue = Math.round(value ?? 0);

	return (
		<Box sx={{ flexGrow: 1, marginTop: '5px' }}>
			<LinearProgress
				sx={{
					'height': 6,
					'backgroundColor': lighten(backgroundColor, 0.5),
					'& .MuiLinearProgress-bar': {
						borderRadius: 20,
						backgroundColor,
					},
				}}
				variant="determinate"
				value={roundedValue}
			/>
		</Box>
	);
};
